<template>
  <div>
    <section class="uk-margin">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link to="/admin">Администрирование</router-link>
          </li>
          <li class="is-active">
            <a href="#">Отзывы</a>
          </li>
          <li>
            <a href="#" @click.prevent="add()">Добавить</a>
          </li>
        </ul>
      </nav>
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
    <section class="uk-margin">
      <b-field grouped group-multiline>
        <b-field label="Сортировка">
          <b-select v-model="filters.order" @input="pageChange()">
            <option value="asc">Восходящая (ASC)</option>
            <option value="desc">Нисходящая (DESC)</option>
          </b-select>
        </b-field>
        <b-field label="На страницу">
          <b-select v-model="filters.limit" @input="pageChange()">
            <option
              v-for="option in limits"
              :value="option"
              :key="option">
              {{ option }} шт.
            </option>
          </b-select>
        </b-field>
        <b-field label="Состояние">
          <b-field>
            <b-select v-model="filters.is_active" placeholder="Filter by State" @input="pageChange()">
              <option
                v-for="option in states"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearState()">X</button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Тип">
          <b-field>
            <b-select v-model="filters.type" placeholder="Filter by type" @input="pageChange()">
              <option
                v-for="option in types"
                :value="option.id"
                :key="option.id">
                {{ option.name }}
              </option>
            </b-select>
            <p class="control">
              <button class="button is-danger" @click="clearType()">X</button>
            </p>
          </b-field>
        </b-field>
      </b-field>
    </section>
    <section class="uk-margin">
      <b-table
        :bordered="true"
        :hoverable="true"
        :data="data"
        :default-sort-direction="filters.order"
        detailed
        detail-key="id">
        
        <template slot-scope="props" @click="click">
          <b-table-column field="id" label="ID" width="40" sortable numeric>
            {{ props.row.id }}
          </b-table-column>
          
          <b-table-column field="date" label="Дата создания" sortable>
            <!-- {{ props.row.date }}
             -->
            {{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:mm:ss') }}
          </b-table-column>

          <b-table-column field="reviewer" label="Имя" sortable>
            {{ props.row.reviewer }}
          </b-table-column>
          
          <b-table-column field="email" label="Email" sortable>
            {{ props.row.email }}
          </b-table-column>

          <b-table-column field="type" label="Тип" sortable>
            {{ props.row.type }}
          </b-table-column>

          <b-table-column field="is_active" label="Состояние" sortable>
            {{ humanState(props.row.is_active) }}
          </b-table-column>
          
          <b-table-column label="Действие" centered>
            <div class="block">
              <a href="#" @click="editRow(props.row.id)">
                <b-icon icon="pen" type="is-dark" size="is-small"></b-icon>
              </a>
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon
                  icon="sad-tear"
                  size="is-large">
                </b-icon>
              </p>
              <p>Данных нет.</p>
            </div>
          </section>
        </template>

        <template slot="detail" slot-scope="props">
          <div class="card-content">
            <div class="media">
              <div class="media-left">
                <figure class="image is-48x48">
                  <img src="https://bulma.io/images/placeholders/96x96.png" alt="Placeholder image">
                </figure>
              </div>
              <div class="media-content">
                <p class="title is-4">{{ props.row.reviewer }}</p>
                <p class="subtitle is-6">{{ props.row.email }}</p>
              </div>
            </div>

            <div class="content">
              <div class="app-review-message">
              {{ props.row.message }}
              </div>
              <br>
              <time :datetime="moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD')">
                <strong>{{ moment(props.row.date).add(moment().utcOffset(), 'minute').format('YYYY-MM-DD HH:mm:ss') }}</strong>
              </time> #{{ moment(props.row.date).add(moment().utcOffset(), 'minute').fromNow() }}
            </div>
          </div>
        </template>
      
      </b-table>
      
    </section>
    <section class="uk-margin">
      <b-pagination
        :total="total"
        :current="currentPage"
        :simple="false"
        :per-page="filters.limit"
        :paginated="false"
        :pagination-simple="true"
        order="is-right"
        @change="pageChange">
      </b-pagination>
    </section>
  </div>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { EventBus } from '@/utils'
export default {
  name: "ReviewTable",
  data() {
    const data = []
    const limits = [
      5, 10, 20, 25, 50, 75, 100
    ]
    const states = [
      {
        id: true,
        name: "Разрешена публикация"
      },
      {
        id: false,
        name: "Не разрешена публикация"
      }
    ]
    const types = [
      {
        id: "review",
        name: "Отзыв"
      },
      {
        id: "feedback",
        name: "Обратная связь"
      }
    ]
    return {
      data: data,
      states: states,
      types: types,
      limits: limits,
      currentPage: 1,
      total: 0,
      filters: {
        is_active: null,
        order: 'asc',
        limit: 25
      }
    }
  },
  mounted: function() {
    let $this = this

    this.$store.dispatch('getReviews')
      .then(response => {
        let data = response.data;
        this.total = data.total
        data.data.forEach((item) => {
          this.data.push(item)
        })
      })
      .catch(error => {
        this.data = []
      })
    
    EventBus.$on('successCreateReview', (data) => {
      this.data.push(data)
    })

    EventBus.$on('failedCreateReview', (msg) => {
      this.$toast.open({
        message: `${this.$i18n.t('admin.create_error')} ${msg}`,
        type: 'is-danger',
        position: 'is-bottom'
      })
    })

    EventBus.$on('successUpdateReview', () => {
      $this.pageChange()
    })
  },
  beforeDestroy: function(){
    EventBus.$off('successCreateReview')
    EventBus.$off('successUpdateReview')
    EventBus.$off('failedCreateReview')
  },
  methods: {
    add(item){
      EventBus.$emit("showModal", "review.add", null)
    },
    editRow(item){
      EventBus.$emit("showModal", "review.edit", item)
    },
    humanState: function(value){
      let name = this.states.filter(function(state) {
        return state.id === value;
      })
      .map(function(state) {
        return state.name;
      }); 
      if (name.length){
        return name[0]
      }
      else{
        return ""
      }
    },
    clearState(){
      this.filters.is_active = null
      this.pageChange()
    },
    clearType(){
      this.filters.type = null
      this.pageChange()
    },
    pageChange(page){
      if(page){
        this.currentPage = page
      }
     
      this.$store.dispatch('getPageReviews', { page: this.currentPage, filters: this.filters })
        .then(response => {
          let data = response.data;
          
          this.data = []
          this.total = data.total
          data.data.forEach((item) => {
            this.data.push(item)
          })

        })
        .catch(error => {
          this.data = []
        })
    }
  }
}
</script>

<style>
.app-review-message {
  word-break: break-all;
}
</style>
